export function servicesNote() {

    const promptIcon = document.querySelectorAll('.js-promptIcon');

    promptIcon.forEach( item => {
        let cardItem = item.closest('.js-servicesCard');

        // Создаем блок
        let textBlock = document.createElement('div'),
            textLink = document.createElement('a');

        // Обрезка текста
        let textLength = 165,
            promptText = cardItem.dataset.note,
            textArr = promptText.split('');

        if (promptText.length > textLength) {
            textArr.forEach( (elem, index) => {
                if (index >= textLength) {
                    textArr.splice(textLength, index);
                }
            });
            promptText = textArr.join('') + '...';
        }

        textLink.setAttribute('am-prompt-link', 'services');
        textLink.href = cardItem.href;
        textLink.textContent = 'Подробнее';

        textBlock.setAttribute('am-prompt-text', 'services');
        textBlock.textContent = promptText;
        textBlock.appendChild(textLink);

        // Удаляем блок при mouseleave
        textBlock.addEventListener('mouseleave', () => {
            textBlock.style.opacity = 0;
            setTimeout(() => {
                textBlock.remove();
                textBlock.style.opacity = '';
            }, 400);
        });

        item.addEventListener('click', e => {
            e.preventDefault();

            let block = document.querySelector('[am-prompt-text="services"]');
            if (block) {
                block.remove();
            }

            // Задаем блоку кординаты
            textBlock.style.top = e.pageY + 20 + 'px';
            textBlock.style.left = e.pageX + 'px';

            document.body.appendChild(textBlock);

            // Не вышел ли блок за экран
            let textBlockRect = textBlock.getBoundingClientRect();

            if (textBlockRect.left < 0) {
                textBlock.style.left = textBlock.offsetWidth / 2 + 'px';
            } else if (textBlockRect.right > window.innerWidth) {
                textBlock.style.left = innerWidth - (textBlock.offsetWidth / 2) - 20 + 'px';
            }
        });
    });
}